// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const baseUrl = "http://192.168.194.248:2021";
export const environment = {
  webSocketEndPoint:'ws://192.168.194.248:2021/collaboration-service/sync',
  production: false,
  contextPath : "/agora",
  fullPath : baseUrl,
  appPath: baseUrl+"/agora",

  // DASHBOARD
  dashboardUrl: baseUrl+"/dashboard-service/dashboard",
  getDashboardCount : baseUrl+"/dashboard-service/dashboard/getDashboardCount",
  
  // ATTACHMENT
  attachmentService : "http://192.168.194.248:2021/attachment-service/attachment/",
  fetchMoMSentListUrl:baseUrl+"/attachment-service/attachment/fetchMoMSentList",
  fetchPdfPreviewUrl:baseUrl+"/attachment-service/attachment/showMintuesPreviewPdf",
  uploadAttachmentUrl:baseUrl+"/attachment-service/attachment/upload",
  deleteAttachmentUrl:baseUrl+"/attachment-service/attachment/deleteAttachment/",
  saveAttachLinkURL:baseUrl+"/attachment-service/attachment-serivce",
  getAttacmentListURL:baseUrl+"/attachment-service/attachment/fetchAttachmentList",
  getAttachmentByIdUrl:baseUrl+"/attachment-service/attachment/getAttachmentById/",
  imageUploadUrl:baseUrl+"/attachment-service/attachment/imageUpload",
  imageDownloadUrl:baseUrl+"/attachment-service/attachment/imageDownload/",
  viewMoMUrl:baseUrl+"/attachment-service/attachment/viewMoM",


  // MINUTES SERVICE
  fetchMomListUrl:baseUrl+"/minutes-service/loadMomList",
  fetchApprovedPdfUrl:baseUrl+"/minutes-service/fetchApprovedPdf",
  saveOrUpdateMomDetailUrl:baseUrl+"/minutes-service/saveOrUpdateMomDetail",
  deleteMomDetailUrl:baseUrl+"/minutes-service/deleteMomDetail",
  fetchAgendaMinutesOfMeeting:baseUrl+"/minutes-service/fetchAgendaMinutesOfMeeting",
  fetchFollowupMeetingInfoWithPagination:baseUrl+"/minutes-service/fetchFollowupMeetingInfoWithPagination",
  fetchAgendaWithActualMinutes:baseUrl+"/minutes-service/fetchAgendaWithActualMinutes",
  copyMomUrl:baseUrl+"/minutes-service/copyMom",
  computeMomGenerationUrl:baseUrl+"/minutes-service/computeMomGeneration",
  previewMinutesUrl:baseUrl+"/minutes-service/loadMinutesPreview",
  previeShareAgMinutes:baseUrl+"/minutes-service/PreviewShareAgMinutes",
  fetchTreeviewMinutes: baseUrl+"/minutes-service/fetchMinutesByMeeting",
  saveTreeviewMinutes: baseUrl+"/minutes-service/saveMinutes",
  fetchMoMDetailURL:baseUrl+"/minutes-service/fetchMoMDetail",
  fetchMoMDetailListByMeeting:baseUrl+"/minutes-service/fetchMoMDetailListByMeeting",
  fetchApprovedMinutesURL:baseUrl+"/minutes-service/fetchApprovedMinutes",
  savePreambleURL:baseUrl+"/minutes-service/updatePreamble",
  saveMinutesAsBlob:baseUrl+"/minutes-service/saveMinutesAsBlob",
  fetchMomApprovedUserName:baseUrl+"/minutes-service/fetchMomApprovedUserName/",
  fetchMinutesByMeetingUrl:baseUrl+"/minutes-service/fetchMinutesByMeetingWithoutUserGrpBy",
  // fetchMinutesByMeetingUrl:"http://localhost:9097/fetchMinutesByMeetingWithoutUserGrpBy",

  // AGENDA SERVICE
  fetchPreviousMeetingInfoByAgendaId:baseUrl+"/agenda-service/agenda/fetchPreviousMeetingInfoByAgendaId",
  fetchAgendaListByMeeting:baseUrl+"/agenda-service/agenda/fetchAgendaListByMeeting",
  fetchAgendaMinutesList:baseUrl+"/agenda-service/agenda/fetchAgendaMinutes",
  saveAgendaUrl:baseUrl+"/agenda-service/agenda/createAgenda",
  updateAgendaUrl:baseUrl+"/agenda-service/agenda/updateAgenda",
  deleteAgendaUrl:baseUrl+"/agenda-service/agenda/deleteAgenda",
  updateResequenceMinutesUrl:baseUrl+"/agenda-service/agenda/updateMinuteSeq",
  fetchAgendaWithMinutesUrl:baseUrl+"/agenda-service/agenda/fetchAgendaDTOByAgendaId",
  agendaSequenceURL:baseUrl+"/agenda-service/agenda/agendaSeqOrder",
  agendaTimerURL:baseUrl+"/agenda-service/agenda",
  fetchAgendaMinutesCountUrl:baseUrl+"/agenda-service/agenda/fetchAgendaMinutesCount/",
  getAllNotesHistory: baseUrl+"/agenda-service/agenda/fetchAgendaListofHistoryByMeeting",
  getAgendaHistory: baseUrl+"/agenda-service/agenda/fetchAllAgendaListofHistoryByMeeting",
  getAllDecisionHistory: baseUrl+"/agenda-service/agenda/fetchAgendaListofHistoryByMeeting",
  getAllTaskHistory: baseUrl+"/agenda-service/agenda/fetchAgendaListofHistoryByMeeting",
  fetchAgendaWithSubListByMeetingId:baseUrl+"/agenda-service/agenda/fetchAgendaWithSubTopics",
  fetchSummarizedText:baseUrl+"/agenda-service/agenda/summariseMinutes",
  agendaMinutesWithMeetingId:baseUrl+"/agenda-service/agenda/agendaMinutesWithMeetingId",

  // agendaMinutesWithMeetingId:"http://192.168.194.248:2021/agenda-service/agenda/agendaMinutesWithMeetingId",

  // TASK SERVICE
  updateTaskStatusByMeeting:baseUrl+"/task-service/updateTaskStatusByMeeting",
  updateGroupTask :baseUrl+"/task-service/updateDashboardTaskInfo/",
  saveTaskUrl:baseUrl+"/task-service/saveTask",
  editTaskUrl:baseUrl+"/task-service/updateTaskInfo",
  saveCommonTaskStatus:baseUrl+"/task-service/updateTaskCommonStatus",
  fetchTaskStatus:baseUrl+"/task-service/getTaskStatusList", 
  deleteTaskUrl:baseUrl+"/task-service/deletetask/",
  fetchTaskInfoUrl : baseUrl+"/task-service/fetchTask/",
  taskServiceURL:baseUrl+"/task-service",
  updateTaskMinute: baseUrl+"/task-service/updateTaskMinute",
  saveTaskAgendaId :baseUrl+"/task-service",
  getTaskHistory: baseUrl+"/task-service/getAuditRecord/",
  sendTask:baseUrl+"/task-service/sendTaskNotification",

  // ATTENDEE SERVICE
  saveParticipant: baseUrl+"/attendee-service/attendee",
  getAttendeeByMeetingURL: baseUrl+"/attendee-service/attendee/getAttendeeListByMeetingId",
  saveAttendeeLogURL:baseUrl+"/attendee-service/attendee/saveAttendeeLog",
  createAttendeURL: baseUrl+"/attendee-service/attendee/createAttendee",
  deleteAttendeeURL: baseUrl+"/attendee-service/attendee/deleteAttendee",
  updateAttendeeURL: baseUrl+"/attendee-service/attendee/updateAttendee",
  fetchAttendeeURL: baseUrl+"/attendee-service/attendee/fetchAttendee",
  userRoleListURL: baseUrl+"/attendee-service/attendee/getUserRoleList",
  userListURL: baseUrl+"/attendee-service/attendee/getUserList",
  getAttendeeLog :  baseUrl+"/attendee-service/attendee/getAttendeeLog/",
  updateAttendeeLog:baseUrl+"/attendee-service/attendee/updateAttendeeLog/",
  attendeeService:baseUrl+"/attendee-service/attendee",
  saveAttendeeLoginFlag:baseUrl+"/attendee-service/attendee/saveAttendeeLogin/",
  fetchAttendeeListObjectById: baseUrl+"/attendee-service/attendee/fetchAttendeeListObjectByMeeting/",
  getAllAttendeeHistory: baseUrl+"/attendee-service/attendee/getAttendeeHistoryListByMeetingId/",


  // MEETING SERVICE
  checkUserAvailability: baseUrl+"/meeting-service/meeting/",
  createNewMeetingUrl:baseUrl+"/meeting-service/meeting/createMeeting",
  fetchMeetingInfoUrl:baseUrl+"/meeting-service/meeting/getMeetingDetails/",
  fetchMeetingConfInfoUrl:baseUrl+"/meeting-service/meeting/getMeetingDetailsInfo",
  fetchMeetingTypeURL:baseUrl+"/meeting-service/meeting/getMeetingTypeList/",
  fetchMeetingMediumURL:baseUrl+"/meeting-service/meeting/getMeetingMediumList/",
  fetchTimeZoneName:baseUrl+"/meeting-service/meeting/getTimeZoneNames",
  fetchCalendarType:baseUrl+"/meeting-service/meeting/getCalendarType",
  updateMeetingInfoUrl:baseUrl+"/meeting-service/meeting/updateMeeting/",
  createRecurParentMeetingUrl:baseUrl+"/meeting-service/recurmeeting/createRecurParentMeeting",
  createRecurChildMeetingUrl:baseUrl+"/meeting-service/recurmeeting/createRecurChildMeeting",
  updateRecurringInfoUrl:baseUrl+"/meeting-service/recurmeeting/updateRecurringInfo",
  saveFollowupMeetingUrl:baseUrl+"/meeting-service/meeting/saveFollowupMeeting",
  meetingServiceURL:baseUrl+"/meeting-service/meeting/",
  endMeetingUrl:baseUrl+"/meeting-service/meeting/endMeeting",
  startMeetingUrl:baseUrl+"/meeting-service/meeting/startMeeting",
  linkMeetingUrl:baseUrl+"/meeting-service/meeting/linkMeeting",
  unLinkMeetingUrl:baseUrl+"/meeting-service/meeting/unLinkMeeting",
  fetchLinkedMeetingUrl:baseUrl+"/meeting-service/meeting/fetchLinkedMeeting",
  deleteMeetingUrl:baseUrl+"/meeting-service/meeting/deleteMeeting/",
  cancelMeetingUrl:baseUrl+"/meeting-service/meeting/cancelMeeting/",
  copyMeeting : baseUrl+"/meeting-service/meeting/copyMeeting/",
  updateMeetingTitleUrl:baseUrl+"/meeting-service/meeting/updateMeetingTitle/",
  updateMeetingConvUrl:baseUrl+"/meeting-service/meeting/updateMeetingConversation/",
  updateSpeechContentUrl:baseUrl+"/meeting-service/meeting/updateMeetingSpeechContent/",
  getMeetingDetailsHistory:baseUrl+"/meeting-service/meeting/getMeetingHistoryDetails",
  getMeetingHistory: baseUrl+"/meeting-service/meeting/getAuditRecord/",
  fetchMeetingWithStatusCodeObject:baseUrl+"/meeting-service/meeting/fetchMeetingStatusCode/",
  recurringInfoUrl:baseUrl+"/meeting-service/recurmeeting/",

  // NOTE SERVICE
  saveNoteUrl:baseUrl+"/note-service/saveNote",
  updateFormDetails:baseUrl+"/note-service/updateFormDetails",
  editNoteUrl:baseUrl+"/note-service/editNote",
  deleteNoteUrl:baseUrl+"/note-service/deleteNote/",
  fetchNotes : baseUrl+"/note-service/fetchNote/",
  updateNoteMinute: baseUrl+"/note-service/updateNoteMinute",
  getHistory: baseUrl+"/note-service/getAuditRecord/",
  // getHistory: baseUrl+"/note-service/getAuditRecord/",

  // DECISION SERVICE
  saveDecisionUrl:baseUrl+"/decision-service/saveDecision",
  editDecisionUrl:baseUrl+"/decision-service/editDecision",
  deleteDecisionUrl:baseUrl+"/decision-service/deleteDecision/",
  fetchDecision : baseUrl+"/decision-service/fetchDecision/",
  updateDecisionMinute: baseUrl+"/decision-service/updateDecisionMinute",
  getDecisionHistory: baseUrl+"/decision-service/getAuditRecord/",

  // USER SERVICE
  userServiceUrl:baseUrl+"/user-service/users/",
  userUrl:baseUrl+"/user-service/users/",

  // LOGIN SERVICE
  loginUrl:baseUrl+"/login-service",
  
  // COLLAB SERVICE
  kafkaProducerUrl:baseUrl+"/collaboration-service/agProducer/producer",
  userLoggingUrl:baseUrl+"/collaboration-service/agProducer/meetingusers", 
  getUsersLogStatusUrl:baseUrl+"/collaboration-service/agProducer/usersstatus",

  // CODELIST SERVICE
  fetchSettingsInfoList:baseUrl+"/codelist-service/orgcontrol/fetchSettingsInfo/",
  saveSettingsInfo: baseUrl+"/codelist-service/orgcontrol/saveSettingsInfo",
  fetchCodeListByCodeAndParentCode:baseUrl+"/codelist-service/orgcontrol/getCodelistByParentAndCode",
  // fetchCodeListByCodeAndParentCode:baseUrl+"/codelist-service/codelist/getCodelistByParentAndCode",


  // SEARCH SERVICE
  searchServiceUrl:baseUrl+"/search-service/search",

  // TEMPLATE SERVICE
  meetingTemplateUrl:baseUrl+"/template-service/meetingtemplate",


  // TULEAP SERVICE
  tuleapUrl : baseUrl+"/tuleap-service/tuleap",

   // ZOOM SERVICE
   zoomURL:baseUrl+"/ZoomWebSDK",
   zoomServiceURL: "http://192.168.194.248:2021/zoom-service/zoom/",

  // REPORT SERVICE
  reportServiceURL : baseUrl+"/report-service/report",
  downloadReportUrl:baseUrl+"/report-service/report/",
  getAllReports: baseUrl+"/report-service/report/",

  taskComStatusCode:"COM",
  taskPendingStatusCode:"P",
  taskReviewClosedStatusCode:"RC",
  noteEntityType:"MN",
  decisionEntityType:"MD",
  taskEntityType:"AI",
  defAttendeeRoleCode:"ATT",
  parentCode:"ROLE",
  AttendeeIsPresent:"Y",
  approvedMomStatus:"A",
  pendingStatus:16,
  defMeetingDuration:60,
  defMeetingTitle:"Untitled Meeting",
  instantMeeting:"Instant Meeting",
  defAgendaTitle: "Untitled Agenda",
  ckeditorScriptUrl:"assets/js/ckeditor.js",
  phemeURL:"http://192.168.194.248:2021/Pheme",
  subscriptionKey:"d39999dc33c34f4bb1df39ebe66ae4a6",
  country:"eastus", 
  speechLanguage:"en-US",
 zoomAuthorizeEndpointURL : "https://zoom.us/oauth/authorize?client_id=EfRTPmPQQxWFx8mFAb9mlA&response_type=code&redirect_uri=https%3A%2F%2Flocalhost%2Fzoom-service%2Fzoom%2FauthZoom",
 //zoomAuthorizeEndpointURL:"https://zoom.us/oauth/authorize?client_id=gr_04sd3Ta9bum2BCr6UQ&response_type=code&redirect_uri=https%3A%2F%2Flocalhost%2Fzoom-service%2Fzoom%2FauthZoom",
 audioServiceUrl : "http://192.168.193.47:2023/audio/",
 getAudioAttachmentByIdUrl:"",
 getAllProteanForm : 'http://192.168.194.248:9095/CreateForm/api/v3/viewforms',
  getFormDetails : 'http://192.168.194.248:9095/CreateForm/api/v3/generate/formHtml',
  saveFormResponse : 'http://192.168.194.248:9095/SaveResponse/api/v3/form-responses',
  getFormResposeDetails : 'http://192.168.194.248:9095/CreateForm/api/v3/generate/formResponseHtml',
  formResposeDetails : baseUrl+"/note-service/",
  //createNewMeetingUrl:"http://localhost:2021/meeting/createMeeting",
  // fetchMeetingInfoUrl:"http://localhost:2021/meeting/getMeetingDetails/",
  //updateMeetingInfoUrl:"http://localhost:2021/meeting/updateMeeting/",
  //createRecurParentMeetingUrl:"http://localhost:2021/recurmeeting/createRecurParentMeeting",
  //createRecurChildMeetingUrl:"http://localhost:2021/recurmeeting/createRecurChildMeeting",
  //saveFollowupMeetingUrl:"http://localhost:2021/meeting/saveFollowupMeeting",
  // saveNoteUrl:"http://localhost:9095/saveNote",

  //editNoteUrl:"http://localhost:9095/editNote",
  // saveDecisionUrl:"http://localhost:9998/saveDecision",
  // saveTaskUrl:"http://localhost:9097/saveTask",

  // editTaskUrl:"http://localhost:9097/updateTaskInfo",


   //UI Team changes Task ID based data
   //meetingServiceURL:"http://localhost:2021/meeting/",
  // startMeetingUrl:"http://localhost:2021/meeting/startMeeting",

  // previewMinutesUrl:"http://localhost:9097/loadMinutesPreview",

  // fetchSettingsInfoList:"http://localhost:9091/orgcontrol/fetchSettingsInfo/",

  // fetchMoMDetailListByMeeting:"http://localhost:9097/fetchMoMDetailListByMeeting",
   //meetingTemplateUrl:"http://localhost:9092/meetingtemplate",
   //updateMeetingTitleUrl:"http://localhost:2021/meeting/updateMeetingTitle/",
   
   //zoomURL:"https://localhost/ZoomWebSDK",
  //  saveMeetingTimer:"http://localhost:9099/meeting",
  // getHistory: "http://localhost:9095/getAuditRecord/",
  // getAllNotesHistory: "http://localhost:2024/agenda/fetchAgendaListofHistoryByMeeting",


  // getAllDecisionHistory: "http://localhost:2024/agenda/fetchAgendaListofHistoryByMeeting",

  // getMeetingHistory:baseUrl+"/meeting-service/getAuditRecord/",
//   getMeetingHistory: "http://192.168.194.248:2021/meeting-service/meeting/getAuditRecord/",
//   getAllTaskHistory: "http://192.168.194.248:2021/agenda-service/agenda/fetchAgendaListofHistoryByMeeting",
//   zoomServiceURL: "http://192.168.194.248:2021/zoom-service/zoom/",
//   //zoomServiceURL: "http://localhost:2000/zoom/",
//  zoomAuthorizeEndpointURL : "https://zoom.us/oauth/authorize?client_id=EfRTPmPQQxWFx8mFAb9mlA&response_type=code&redirect_uri=https%3A%2F%2Flocalhost%2Fzoom-service%2Fzoom%2FauthZoom",
//   //zoomAuthorizeEndpointURL:"https://zoom.us/oauth/authorize?client_id=gr_04sd3Ta9bum2BCr6UQ&response_type=code&redirect_uri=https%3A%2F%2Flocalhost%2Fzoom-service%2Fzoom%2FauthZoom",
// fetchCodeListByCodeAndParentCode:"http://192.168.194.248:2021/codelist-service/codelist/getCodelistByParentAndCode",
//  fetchMeetingWithStatusCodeObject:"http://192.168.194.248:2021/meeting-service/meeting/fetchMeetingStatusCode/",
//  recurringInfoUrl:"http://192.168.194.248:2021/meeting-service/recurmeeting/",
//  audioServiceUrl : "http://192.168.194.248:2021/audio-service/audio/",
//  fetchAgendaWithSubListByMeetingId:"http://192.168.194.248:2021/agenda-service/agenda/fetchAgendaWithSubTopics",
//  getAudioAttachmentByIdUrl:"http://192.168.194.248:2021/attachment-service/attachment/getAudioAttachmentById/",
//  attachmentService : "http://192.168.194.248:2021/attachment-service/attachment/",
//  fetchSummarizedText:"http://192.168.194.248:2021/agenda-service/agenda/summariseMinutes",
//   agendaMinutesWithMeetingId:"http://192.168.194.248:2021/agenda-service/agenda/agendaMinutesWithMeetingId",
  collaboraURL:"https://192.168.195.6:9980/browser/321ff0a561/cool.html?WOPISrc=http://192.168.195.6:8080/docmanage/wopi/files/",
   codeListServiceUrl:"https://vsivanagalakshmi-chn.aithent.com/codelist-service/codelist/",
searchSolrUrl:"http://192.168.193.65:8080/solr/report/",
 fetchNotesByMeeting: 'http://192.168.193.189:9091',
fetchTaskByMeeting:'http://192.168.193.189:9095',
fetchAgendaList:"http://192.168.193.189:2024/agenda"
};
export const environment_const = {
  idisplayLength:10,
  idisplayStart:0,
  TO_LINK_MEETING:"TO_LINK_MEETING",
  followupTypeCode:"FL",
  linkTypeCode:"LN",
  momApproveStatus:"A",
  recurChangeToAll:"ALL",
  recurChangeToCurrent:"CUR",
  patternKey:/\[XXXXXX\]/g
  
};

export const environment_label = {
  label_actual_min:"Acutual min",
  label_planned_min:"Planned min",
  label_discussion:"Discussion",
  label_task:"Task",
  label_note:"Note",
  label_decision:"Decision",
  label_no_data_found:"No Data Found",
  label_not_yet_approved:"MoM Not Yet Approved",
  label_error_unable_to_process:"Unable to process the data currently!",
  label_minutes_not_found:"Minutes not Found",
  label_meeting_type : "Meeting Type",
  label_meeting_location : "Meeting Location",
  label_meeting_medium : "Meeting Medium",
  label_def_approval_hours : "Default Approval Hours",
  label_recur_till_date  : "Till",
  label_create_followup :"Create Follow-up",
  label_weekend_flag :"Weekend Flag",
  label_frequency:"Frequency",
  label_confidential : "Confidential",
  label_preview:"Preview & email MoM draft to all participants",
  label_draft:"Email MoM draft to selected participants",
  label_approve:"Approve MoM & email to selected participants",
  label_approvedUserNames:"Meeting has been approved by"
  
};
export const environment_msg = {
  msg_error_create_mom:"Please add at least one MOM",
  msg_error_select_mom:"Please select at least one MOM.",
  msg_success_task_update:"Task status updated successfully.",
  msg_success_delete_mom:"MoM deleted successfully.",
  msg_success_task_complete:"Task(s) completed successfully",
  msg_error_enter_meeting_location:"Enter the Meeting Location",
  msg_error_enter_notes_to_preview:"Please enter the note to preview it",
  msg_error_enter_notes_to_draft:"Please enter the note to send draft to participants",
  msg_error_enter_notes_to_approve:"Please enter the note to approve it",
  msg_error_enter_notes_to_mom:"Please enter the note to prepare MoM",
  msg_error_mom_already_approved:"All minutes of the meeting has been approved.",
  msg_error_mom_content:"To prepare Minutes of the meeting, at least select one note content from the panel",

  msg_confirm_delete_note : "The Note will be deleted permanently. Please confirm?",
  msg_confirm_delete_decision : "The Decision will be deleted permanently. Please confirm?",
  msg_confirm_delete_task : "The Task will be deleted permanently. Please confirm?",
  msg_confirm_delete_mom : "The MoM will be deleted permanently, Please confirm?",
  msg_confirm_delete_attachment : "The Attachement will be deleted permanently. Please confirm?",
  msg_confirm_delete_agenda : "The Agenda will be deleted permanently. Please confirm?",
  msg_confirm_extend_agendaTime : "Do you want to extend the agenda time? Please confirm",
  msg_confirm_link_meeting : "Do you want to link this meeting? Please confirm.",
  msg_confirm_update_recur_changes : "Do you want to update these changes for all upcoming meetings?",
  msg_confirm_unlink_meeting : "Do you want to unlink this meeting? Please confirm.",
  msg_confirm_delete_participant : "Selected participant will be deleted permanently. Please confirm?",
  msg_confirm_change_facilitator : "Already facilitator was added, Still you want to overwrite it.?",
  msg_error_user_password_expired : "your password as not been changed for 90 days please change your password !",
  msg_error_user_attachment_filesize_exceeded: "Upload File size has exceded the limit Please upload the attachment",
  msg_error_no_previous_agenda_linked: "No Previous Agenda Linked",
  msg_confirm_endmeeting:"Do you want to end the meeting? Please confirm.",
  msg_error_no_previous_history_found:"No history found",
  msg_confirm_docEndmeeting:"Are you sure that the document is complete?",
  msg_error_mandatory_fields:"Please enter all required fields",
  msg_success_data_saved:"Data saved successfully",
  msg_error_enter_one_answer:"Please enter atleast one answer",
  msg_error_enter_password:"Please enter a password",
  msg_error_password_cannot_empty:"The password field cannot be empty",
  msg_success_password_changed_success:"Password changed successfully",
  msg_error_select_calendar_type:"Please select a calendar type",
  msg_notify_audio_recording:"Recording has started Let everyone know they're being recorded.",
  msg_notify_recording_for_others:"Recording has started.Started by {sentByUserName}. By attending this meeting, you consent to being recorded.",
  msg_success_textConvertion : "It will take time, Once completed we will notify you",
  msg_error_mic : "Allow mic then only you can record"
};

export const environment_accessErrMsg ={
  msg_modifyrightsalert : "User does not have rights to modify",
  msg_deleterightsalert : "User does not have rights to delete",
  msg_addrightsalert : "User does not have rights to add",
  msg_viewrightsalert : "User does not have rights to view"
}

const userEnv = (window as any).environment_qa_prod;
if(userEnv!=undefined && userEnv!=null){
  if (userEnv) Object.assign(environment, userEnv);
}
const userEnvConst = (window as any).environment_qa_prod_const;
if(userEnvConst!=undefined && userEnvConst!=null){
  if (userEnvConst) Object.assign(environment_const, userEnvConst);
}
const userEnvLabel = (window as any).environment_qa_prod_label;
if(userEnvLabel!=undefined && userEnvLabel!=null){
  if (userEnvLabel) Object.assign(environment_label, userEnvLabel);
}

const userEnvMsg = (window as any).environment_qa_prod_msg;
if(userEnvMsg!=undefined && userEnvMsg!=null){
  if (userEnvMsg) Object.assign(environment_msg, userEnvMsg);
}

export const snackbarConfigurations = {
  horizontal : "start",
  vertical : "bottom"
}

//Tour information
export const layoutTourValues = {
  tourBeginner : "Welcome to Agora guide. Click next to begin",
  layoutFirstStep : "Click on the '+' icon to create an instant meeting or to schedule a meeting for later.",
  layoutSecondStep : "Click here to view Agora Dashboard, which contains information about Announcements, Upcoming Meetings, Tasks, and Past Meetings.",
  layoutThirdStep : "Click here to view the Calendar.",
  layoutFourthStep : "Click here to search for Tasks from your meetings. And use a filter to sort out your requirements.",
  layoutFifthStep : "Click here to search for meetings information. And use a filter to sort out your requirements.",
  layoutSixStep : "Click here to view settings and change application configuration.",
  layoutSevenStep : "Click here to view user profile information",
  layoutEightStep : "Click here to open Pheme",
  layoutNineStep : "Click here to view the report.",
  layoutTenthStep : "Click here to activate the user account.",
  layoutElevenStep : "Click here to view the Agora report.",
  layoutTweleveStep: "Click here to view help video to learn about Agora."
}

export const dashboardTourValues = {
  dashboardFirstStep :"View current running meetings and future scheduled meetings." ,
  dashboardSecondStep : "View task assigned to you and overall task information, status and it's corresponding meeting",
  dashboardThirdStep :"View past meetings, MOM, the meeting approved or not information.",
  dashboardFourthStep : "View the documentation of each meeting." ,
  dashboardFifthStep : "View the latest updates and announcements." 
}

export const meetingTourValues = {
	meetFirstStep : "Click to edit meeting title and to open meeting description panel",
	meetSecondStep : "You can change or edit meeting title in this place",
	meetDescFirstStep : "Meeting date and minutes can be customised",
	meetDescSecondStep : "Meeting Information can be viewed in this section after clicking the pencil icon close to the meeting title",
  meetParticipantFirstStep: "Add participant to your presentation",
  meetAgendaFirstStep : "Update or edit meeting agenda title",
  meetAgendaTwoStep : "Track individual presentation time",
  meetAgendaThreeStep : "Add attachment and links to your presentation",
  meetAgendaFourStep : "Click to view more options in agenda",
  meetAgendaFiveStep : "Add new agenda, notes, task and decision using '+' button for each agenda",
  meetNoteOneStep: "Add notes to your presentation",
  meetNoteTwoStep: "Add attachment and link to your note",
  meetNoteThreeStep: "Click to view more options for notes",
  meetTaskOneStep : "Add task and assign to team members during the presentation",
  meetTaskTwoStep : "Add attachment and links for reference to task",
  meetTaskThreeStep : "Click to view more options for task",
  meetDecisionFirstStep : "Add important decisions made during the presentation",
  meetDecisionSecondStep : "Add attachment and links to your meeting",
  meetDecisionThirdStep : "Click to view more options for decision",
  meetShotcutFirstStep : "Below commonly used keywords to add agenda, notes, tasks and decision during presentation using keyboard. It can be typed in the input fields of agenda, note, task and decision",
  meetShortcutSecondStep : "Click here to view more shortcuts to use in application"
}

export const scheduleMeetingTourValues = {
  meetFirstStep : "Click to edit the meeting title and open the meeting description panel.",
	meetSecondStep : "You can change or edit the meeting title to schedule meetings for future.",
	meetDescFirstStep : "Meeting dates and minutes can be changed to suit your needs.",
	meetDescSecondStep : "Meeting information can be viewed and edited. In this place meeting can be configured by changing the type of meeting, default approve hours, what type of project going to discuss, private or public meeting, meeting medium (Agora, Jitsi, Zoom), location of the meeting, and frequency (meeting will be scheduled daily or once).",
  meetParticipantFirstStep: "Add participants to this meeting. So participants can view the scheduled meeting in their upcoming meeting section on the dashboard.",
  meetAgendaFirstStep : "Update or edit the meeting agenda title.",
  meetAgendaTwoStep : "Track your individual presentation time.",
  meetAgendaThreeStep : "Add predefined attachments and links to your presentation that wanted to view during your presentation.",
  meetAgendaFourStep : "Click to view more options in the agenda.",
  meetAgendaFiveStep : "Add new agenda, notes, tasks, and decisions using the '+' button for each agenda.",
  meetNoteOneStep: "Add predefined notes to your presentation.",
  meetNoteTwoStep: "Add a predefined attachment and link to your note.",
  meetNoteThreeStep: "Click to view more options for notes.",
  meetTaskOneStep : "Add predefined tasks and assign them to team members for future meetings and also able track the status.",
  meetTaskTwoStep : "Add predefined attachments and links for reference to the task.",
  meetTaskThreeStep : "Click to view more options for the task.",
  meetDecisionFirstStep : "Add important predefined decisions made for the future presentation.",
  meetDecisionSecondStep : "Add predefined attachments and links to your meeting.",
  meetDecisionThirdStep : "Click to view more options for decision.",
  meetShotcutFirstStep : "Below are commonly used keywords to add agenda, notes, tasks, and decisions during the presentation using the keyboard. It can be typed in the input fields of the agenda, note, task, and decision.",
  meetShortcutSecondStep : "Click here to view more shortcuts to use in the application.",
  scheduleMeetingBtnOne : "Click start to begin the meeting now.",
  scheduleMeetingBtnTwo : "Click on schedule to schedule the meeting for the future.",
  scheduleMeetingBtnThree : "Click here to reschedule a meeting with future changes."
}

export const pastMeetingTourValues = {
  pastInitialStep : "Click here to visit the view mom page. (Note:- At least one minutes need to be present in the meeting to go to the minute's page), preview & email the MOM draft to all participants, email the MOM draft to selected participants, approve MOM & email it to selected participants (Note:- Once the meeting is approved contents in the meeting cannot be edited).",
	meetFirstStep : "Click here to edit meeting title",
  meetSecondStep : "You can change or edit meeting title to schedule meeting for future",
	pastSecondOneStep : "View what time and date the meeting took place.",
	meetDescFirstStep : "Meeting date and minutes can be customised",
	meetDescSecondStep : "Meeting Information can be viewed in this section after clicking the pencil icon close to the meeting title",
  pastSecondStep : "View the participants taking place in the meeting.",
  meetParticipantFirstStep: "Add participant to your presentation",
  pastThirdStep : "View minutes taken in the meeting and check the status of each task assigned to individuals.",
  meetAgendaFirstStep : "Update or edit meeting agenda title",
  meetAgendaTwoStep : "Track individual presentation time",
  meetAgendaThreeStep : "Add attachment and links to your presentation",
  meetAgendaFourStep : "Click to view more options in agenda",
  meetAgendaFiveStep : "Add new agenda, notes, task and decision using '+' button for each agenda",
  meetNoteOneStep: "Add notes to your presentation",
  meetNoteTwoStep: "Add attachment and link to your note",
  meetNoteThreeStep: "Click to view more options for notes",
  meetTaskOneStep : "Add task and assign to team members during the presentation",
  meetTaskTwoStep : "Add attachment and links for reference to task",
  meetTaskThreeStep : "Click to view more options for task",
  meetDecisionFirstStep : "Add important decisions made during the presentation",
  meetDecisionSecondStep : "Add attachment and links to your meeting",
  meetDecisionThirdStep : "Click to view more options for decision",
  meetShotcutFirstStep : "Below commonly used keywords to add agenda, notes, tasks and decision during presentation using keyboard. It can be typed in the input fields of agenda, note, task and decision",
  meetShortcutSecondStep : "Click here to view more shortcuts to use in application"
}

export const searchTourValues = {
  searchFirstStep : 'Using a date filter the exact date match can be found. Which will reduce your search for required data in the table.',
  searchSecondStep : 'Using the meeting title, The meeting which you wanted to view can be filtered easily.',
  searchThirdStep : 'If you know the agenda title. Then it is really simple to filter the exact meeting based on the agenda title.',
  searchFourthStep : 'The facilitator can be used in this drill-down filter to bring back better search results for the meeting.',
  searchFiveStep : 'Based on participants drill down filter can be done. So it will bring back better results in a large amount of meetings scenarios.',
  searchSixStep : 'Meeting type can be provided as instant, default to filter meetings based on its type.',
  searchSevenStep : 'If you have a huge number scheduled, yet to schedule and completed meetings. Using the status filter you can reduce your burden to find out the meeting you wanted to view or start.',
  searchEightStep : 'Confidentital column is used to indicate whether meetinThe confidential column is used to indicate whether the meeting is private or public. You can add the confidential column to your drill-down filter for better search results.',
  searchNineStep : 'So if you wanted to clear all the filters after performing the drill-down operation. Please use clear all to erase the filtered inputs.',
  searchTenStep : 'A huge set of records are restricted for normal view. So use pagination to navigate to pages and items per page to customize your number of records per page.',
  searchElevenStep : 'Before navigating to the meeting page you can view information about the meeting using the information icon.',
  searchTwelveStep : 'Meeting page can be navigated by click on linkThe meeting page can be navigated by click on the link.',
}

export const taskTourValues = {
  taskFirstStep : 'Using a task title filter, The task which you wanted to filter from the huge records set can be sorted out easily.',
  taskSecondStep : 'If you know the task assignee name you can add it to this filter to get better search results.',
  taskThirdStep : 'If you know the task assigned to the name you can add it to this filter to get better search results.',
  taskFourthStep : 'A Facilitator can be used in this drill down filter to bring back better search results for the meeting.',
  taskFiveStep : 'Due or completion date can be used to filter out the completed tasks which were not completed on the deadline.',
  taskSixStep : 'Pending, reviewed/closed and completed keywords can be used to filter tasks.',
  taskSevenStep : 'If you wanted to filter out task records based on a meeting title. You can add a meeting title filter to sort out the tasks.',
  taskEightStep : 'Task-based meeting navigation can be done by clicking on this link.',
  taskNineStep : 'So if you wanted to clear all the filters after performing the drill-down operation. Please use clear all to erase the filtered inputs.',
  taskTenStep : 'A huge set of records are restricted for normal view. So use pagination to navigate to pages and items per page to customize your number of records per page.',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
